import React from 'react';
import './LZPrivacyAuthPage.css';

class LZPrivacyAuthPage extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {

    }
    
    render() {
        return (
            <>
                <div className='main-header'>应用权限申请与使用情况说明</div>
                <div className='header-content'>1、为保障莱泽之家App相关产品或服务能实现与安全稳定运行之目的，我们可能会申请或使用操作系统的相关权限；</div>
                <div className='header-content'>2、为保障您的知情权，我们通过下列列表将产品或服务可能申请、使用的相关操作系统权限进行展示，您可以根据实际需要对相关权限进行管理；</div>
                <div className='header-content'>3、根据产品或服务的升级，申请、使用权限的类型与目的可能会有变动，我们将及时根据这些变动对列表进行调整，以确保您及时获悉权限的申请与使用情况
安卓操作系统应用权限列表</div>
                <br/>
                <div className='table-header'>安卓操作系统应用权限列表</div>
                <table className='table1' cellSpacing={0} cellPadding={0}>
                    <thead>
                        <tr>
                            <td>权限名称</td>
                            <td>权限功能说明</td>
                            <td>使用场景或目的</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th>android.permission.CAMERA（摄像头）</th>
                            <th>收集字段：拍摄内容；收集方式：拍摄视频、照片、扫码；收集频率：使用视频拍摄、拍照、扫码以及人脸识别登录时</th>
                            <th>客服聊天场景下，您可拍摄照片/视频给客服，用于咨询您的购物需求以及客服与售后需求等</th>
                        </tr>
                        <tr>
                            <th>【Android 13系统以下】android.permission.WRITE_EXTERNAL_STORAGE（读取存储），android.permission.READ_EXTERNAL_STORAGE（写入存储）；
    【Android 13系统及以上】android.permission.READ_MEDIA_IMAGES（图片），android.permission.READ_MEDIA_VIDEO（视频）</th>
                            <th>收集字段：照片/视频；收集方式：上传照片/视频；收集频率：使用上传照片/视频时</th>
                            <th>客服聊天场景下，您可将相册中的照片/视频发送给客服，用于咨询您的购物需求以及客服与售后需求等</th>
                        </tr>
                        <tr>
                            <th>android.permission.RECORD_AUDIO（麦克风）</th>
                            <th>收集字段：录音内容；收集方式：录音；收集频率：使用语音输入、语音搜索、网络电话服务时</th>
                            <th>识别您的购物需求以及客服与售后需求</th>
                        </tr>
                        <tr>
                            <th>剪切板</th>
                            <th>访问剪切板内容</th>
                            <th>复制、分享商品信息、标题、短信验证码</th>
                        </tr>
                        <tr>
                            <th>android.permission.INTERNET</th>
                            <th>访问网络权限</th>
                            <th>实现应用程序联网</th>
                        </tr>
                        <tr>
                            <th>android.permission.ACCESS_WIFI_STATE</th>
                            <th>获取WiFi状态权限</th>
                            <th>监控网络变化，提示用户当前网络环境</th>
                        </tr>
                        <tr>
                            <th>android.permission.ACCESS_NETWORK_STATE</th>
                            <th>获取网络状态权限</th>
                            <th>监控网络变化，提示用户当前网络环境</th>
                        </tr>
                        <tr>
                            <th>android.permission.WRITE_SETTINGS</th>
                            <th>允许写设备缓存/允许程序读取或写入系统设置</th>
                            <th>微信和支付宝SDK的支付和登录功能</th>
                        </tr>
                    </tbody>
                </table>
                <br/>
                <div className='table-header'>iOS操作系统应用权限列表</div>
                <table className='table1' cellSpacing={0} cellPadding={0}>
                    <thead>
                        <tr>
                            <td>权限名称</td>
                            <td>权限功能说明</td>
                            <td>使用场景或目的</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th>NSLocationAlwaysAndWhenInUseUsageDescription（使用APP期间及始终允许获取位置）；NSLocationAlwaysUsageDescription（始终允许获取位置）；NSLocationWhenInUseUsageDescription（使用APP期间允许获取位置）</th>
                            <th>收集字段：精准位置；收集方式：通过全球定位系统（GPS）或网络位置信息（例如基站或WLAN）获取精准地理位置；收集频率：根据用户设置频率收集</th>
                            <th>客服聊天场景下，您可向客服发送您所在的位置，用于向客服咨询运费或其他购物相关需求等</th>
                        </tr>
                        <tr>
                            <th>NSCameraUsageDescription（摄像头）</th>
                            <th>收集字段：拍摄内容；收集方式：拍摄视频、照片、扫码；收集频率：使用视频拍摄、拍照、扫码以及人脸识别登录时</th>
                            <th>客服聊天场景下，您可拍摄照片/视频给客服，用于咨询您的购物需求以及客服与售后需求等</th>
                        </tr>
                        <tr>
                            <th>NSPhotoLibraryAddUsageDescription（相册）；NSPhotoLibraryUsageDescription（相册使用）</th>
                            <th>收集字段：照片/视频；收集方式：上传照片/视频；收集频率：使用上传照片/视频时</th>
                            <th>客服聊天场景下，您可将相册中的照片/视频发送给客服，用于咨询您的购物需求以及客服与售后需求等</th>
                        </tr>
                        <tr>
                            <th>NSMicrophoneUsageDescription（麦克风）</th>
                            <th>收集字段：录音内容；收集方式：录音；收集频率：使用语音输入、语音搜索、网络电话服务时</th>
                            <th>识别您的购物需求以及客服与售后需求</th>
                        </tr>
                    </tbody>
                </table>
            </>
        );
    }
}

export default LZPrivacyAuthPage;